// Tarjetas Visa

const on = {
  regional: [
    {
      title: '10 dólares, 1 Dot',
      icon: 'tickets',
      content: [
        'Cada vez que realices una compra con tu tarjeta de crédito Itaú VISA On Punta Carretas acumulás Dots, que podés canjear por premios exclusivos, pasajes ida y vuelta con kilómetros LATAM Pass, Smiles y en Buquebus.',
        'Además, podés cambiar tus Dots por importantes premios de marcas exclusivas y por Gift Cards de Punta Carretas, para comprar en cualquier local del shopping y obtener beneficios adicionales en todos los eventos de descuentos.',
      ],
    },
    {
      title: 'Adicionales sin cargo',
      icon: 'plusone',
      content: [
        'La primera adicional es sin cargo. Además generan Dots a la cuenta On del titular. La tarjeta Visa On Regional del titular y sus adicionales no tienen costo de emisión por un año.',
      ],
    },
    {
      title: 'Tipo de emisión',
      icon: 'document',
      content: [
        'La tarjeta Visa Regional tiene un tipo de emisión automática. Esto significa que simplemente completando el formulario de solicitud, <strong>nuestro sistema validará automáticamente tu tarjeta sin que tengas que presentar documentación ni recibos de sueldo</strong>. Si tus datos validan con nuestro sistema, tu tarjeta queda aprobada y te la enviamos en 48 horas sin moverte de tu casa.',
      ],
    },
    {
      title: 'Crédito',
      icon: 'money-circle',
      content: [
        'El límite de crédito será definido según nuestras políticas y está sujeto a aprobación crediticia.',
      ],
    },
    {
      title: 'Bono de 50 Dots',
      icon: 'star',
      content: ['Bono bienvenida de 50 Dots.'],
    },
    {
      title: 'Dots por consumo',
      icon: 'cart',
      content: [
        'Todos los consumos que realizás con tu Visa On generan Dots, a excepción de los retiros de dinero en efectivo y los cargos por intereses o cargos por parte del Banco (comisiones).',
        'El consumo de combustible y los débitos automáticos también generan Dots',
      ],
    },
  ],
  internacional: [
    {
      title: '10 dólares, 1 Dot',
      icon: 'tickets',
      content: [
        'Cada vez que realices una compra con tu tarjeta de crédito Itaú VISA On Punta Carretas acumulás Dots, que podés canjear por premios exclusivos, pasajes ida y vuelta con kilómetros LATAM Pass, Smiles y en Buquebus.',
        'Además, podés cambiar tus Dots por importantes premios de marcas exclusivas y por Gift Cards de Punta Carretas, para comprar en cualquier local del shopping y obtener beneficios adicionales en todos los eventos de descuentos.',
      ],
    },
    {
      title: 'Adicionales sin cargo',
      icon: 'plusone',
      content: [
        'La tarjeta titular y la primera adicional son sin costo de emisión. Las tarjetas adicionales también acumulan Dots en la cuenta titular.',
      ],
    },
    {
      title: 'Tipo de emisión',
      icon: 'document',
      content: [
        'La tarjeta Visa Internacional tiene un tipo de emisión automática. Esto significa que simplemente completando el formulario de solicitud, <strong>nuestro sistema validará automáticamente tu tarjeta sin que tengas que presentar documentación ni recibos de sueldo</strong>. Si tus datos validan con nuestro sistema, tu tarjeta queda aprobada y te la enviamos en 48 horas sin moverte de tu casa.',
      ],
    },
    {
      title: 'Crédito',
      icon: 'money-circle',
      content: [
        'El mínimo es de $25.000. Este crédito puede aumentar automáticamente según lo que nos devuelva el sistema. Si tu ingreso es mayor a $23.000 tu crédito será mayor.',
      ],
    },
    {
      title: 'Bono de 50 Dots',
      icon: 'star',
      content: ['Bono bienvenida de 50 Dots.'],
    },
    {
      title: 'Dots por consumo',
      icon: 'cart',
      content: [
        'Todos los consumos que realizás con tu Visa On generan Dots, a excepción de los retiros de dinero en efectivo y los cargos por intereses o cargos por parte del Banco (comisiones).',
        'El consumo de combustible y los débitos automáticos también generan Dots',
      ],
    },
  ],
  oro: [
    {
      title: '10 dólares, 1 Dot',
      icon: 'tickets',
      content: [
        'Cada vez que realices una compra con tu tarjeta de crédito Itaú VISA On Punta Carretas acumulás Dots, que podés canjear por premios exclusivos, pasajes ida y vuelta con kilómetros LATAM Pass, Smiles y en Buquebus.',
        'Además, podés cambiar tus Dots por importantes premios de marcas exclusivas y por Gift Cards de Punta Carretas, para comprar en cualquier local del shopping y obtener beneficios adicionales en todos los eventos de descuentos.',
      ],
    },
    {
      title: 'Adicionales sin cargo',
      icon: 'plusone',
      content: [
        'La primera adicional es sin cargo. Además generan Dots a la cuenta On del titular. La tarjeta Visa On Oro del titular y sus adicionales no tienen costo de emisión por un año.',
      ],
    },
    {
      title: 'Tipo de emisión',
      icon: 'document',
      content: [
        'La tarjeta Visa On Oro tiene un tipo de emisión automática. Esto significa que simplemente completando el formulario de solicitud, <strong>nuestro sistema validará automáticamente tu tarjeta sin que tengas que presentar documentación ni recibos de sueldo</strong>. Si tus datos validan con nuestro sistema, tu tarjeta queda aprobada y te la enviamos en 48 horas sin moverte de tu casa.',
      ],
    },
    {
      title: 'Crédito',
      icon: 'money-circle',
      content: [
        'El límite de crédito será definido según nuestras políticas y está sujeto a aprobación crediticia.',
      ],
    },
    {
      title: 'Bono de 50 Dots',
      icon: 'star',
      content: ['Bono bienvenida de 50 Dots.'],
    },
    {
      title: 'Dots por consumo',
      icon: 'cart',
      content: [
        'Todos los consumos que realizás con esta tarjeta generarán Dots, a excepción de los retiros de dinero en efectivo y los cargos por intereses o cargos bancarios (comisiones).',
        'El consumo de combustible y los débitos automáticos también generan Dots.',
      ],
    },
  ],
  platinum: [
    {
      title: '10 dólares, 1 Dot',
      icon: 'tickets',
      content: [
        'Cada vez que usás tu tarjeta Itaú Visa On dentro y fuera de Punta Carretas Shopping acumulás Dots que podés canjear por vales obsequio para usar en todos los locales, excepto Abitab, Cambio Indumex, Redpagos, Movie, Metraje de OCA y Devoto.',
        'Por cada 10 dólares de consumo, o su equivalente de pesos, acumulás un Dots, con excepción de los cargos bancarios.',
      ],
    },
    {
      title: 'Priority Pass',
      icon: 'vip',
      content: [
        'Los titulares de la tarjeta Visa Platinum e Infinite de Itaú reciben junto con ésta la tarjeta Priority Pass. La misma permite ser parte del programa independiente de acceso a salas VIP de aeropuertos más amplio del mundo.',
        'La tarjeta Priority Pass te brinda 7 accesos gratis al año (calendario). A partir del octavo acceso, se cargará a la tarjeta de crédito del titular cada acceso adicional a USD 27.',
        'Para ver la lista de Salas Vip adheridas y bases y condiciones hacé <a href="https://www.prioritypass.com/en/airport-lounges">click aquí</a>.',
      ],
    },
    {
      title: 'Servicio de asistencia médica en Viaje: Cobertura brindada por Universal Assistance',
      icon: 'lock',
      content: [
        '<strong>Área de Cobertura:</strong> Todo el mundo (excepto la República Oriental del Uruguay).',
        '<strong>Beneficiarios:</strong> Tarjeta habientes, cónyuges e hijos dependientes menores de 21 años.',
        '<strong>Prestaciones:</strong> Asistencia Médica, Odontológica, Jurídica y Localización de Equipaje.',
        'Los beneficiarios cuentan con el Servicio de Asistencia en Viajes que brinda Universal Assistance de hasta USD 15.000 por persona.',
        'Para solicitar la asistencia a través de Universal Assistance siempre deberás comunicarse con la central operativa correspondiente al lugar donde te encuentres, mediante cobro revertido.',
        '<a href="https://www.itau.com.uy/inst/aci/docs/condiciones_generales.pdf">Ver condiciones</a>',
      ],
    },
    {
      title: 'Cobertura brindada por AXA USA',
      // icon: '',
      content: [
        'Además, si se abona el pasaje de avión con Itaú Visa Platinum, cuentan con la siguiente cobertura a través de AXA USA (*).',
        'Asistencia en Viajes de hasta un máximo de USD 50.000 en todo el mundo.',
        '<strong>Beneficiarios:</strong> titular, cónyuge e hijos menores de 23 años.',
        '<strong>(*)</strong> Los seguros de Asistencia en Viajes no son acumulables.',
        '<strong>(**)</strong> Países firmantes del tratado Schengen.',
        'Para solicitar la asistencia a través de AXA siempre deberás comunicarse con la central operativa correspondiente al lugar donde te encuentres, mediante cobro revertido. Hacé <a href="https://www.itau.com.uy/inst/aci/docs/Seguros%20AXA.pdf">click aquí</a> para ver los números de teléfono.',
        '<a href="https://www.itau.com.uy/inst/aci/docs/servicios_de_emergencia_medica_internacional_AXA_platinum.pdf">Ver condiciones</a>',
        'Si querés solicitar el certificado Schengen para viajes a Europa, regístrate en el portal de Visa haciendo <a href="https://visabenefitslac.axa-assistance.us/">click aquí</a>.',
      ],
    },
    {
      title: 'Seguros',
      // icon: 'lock',
      content: [
        'Por más información sobre seguros <a href="https://www.visa.com.uy/pague-con-visa/tarjetas/credito/visa-platinum.html">clic aquí</a>.',
      ],
    },
    {
      title: 'Adicionales sin cargo',
      icon: 'plusone',
      content: [
        'La primera adicional es sin cargo. Además generan Dots a la cuenta On del titular. La tarjeta Visa On Platinum del titular y sus adicionales no tienen costo de emisión por un año.',
      ],
    },
    {
      title: 'Tipo de emisión',
      icon: 'document',
      content: [
        'La tarjeta Visa On Platinum tiene un tipo de emisión automática. Esto significa que simplemente completando el formulario de solicitud, <strong>nuestro sistema validará automáticamente tu tarjeta sin que tengas que presentar documentación ni recibos de sueldo</strong>. Si tus datos validan con nuestro sistema, tu tarjeta queda aprobada y te la enviamos en 48 horas sin moverte de tu casa.',
      ],
    },
    {
      title: 'Crédito',
      icon: 'money-circle',
      content: [
        'El mínimo es de $120.000. Este crédito puede aumentar automáticamente según lo que nos devuelva el sistema. Si tu ingreso es mayor a $120.000 tu crédito será mayor.',
      ],
    },
    {
      title: 'Bono de 50 Dots',
      icon: 'star',
      content: ['Bono bienvenida de 50 Dots.'],
    },
    {
      title: 'Dots por consumo',
      icon: 'cart',
      content: [
        'Todos los consumos que realizás con esta tarjeta generarán Dots, a excepción de los retiros de dinero en efectivo y los cargos por intereses o cargos bancarios (comisiones).',
        'El consumo de combustible y los débitos automáticos también generan Dots.',
      ],
    },
  ],
  infinite: [
    {
      title: '10 dólares, 1 Dot',
      icon: 'tickets',
      content: [
        'Cada vez que realices una compra con tu tarjeta de crédito Itaú VISA On Punta Carretas acumulás Dots, que podés canjear por premios exclusivos, pasajes ida y vuelta con kilómetros LATAM Pass, Smiles y en Buquebus. Además, podés cambiar tus Dots por importantes premios de marcas exclusivas y por Gift Cards de Punta Carretas, para comprar en cualquier local del shopping y obtener beneficios adicionales en todos los eventos de descuentos.',
      ],
    },
    {
      title: 'Priority Pass',
      icon: 'vip',
      content: [
        'Los titulares de la tarjeta Visa Platinum e Infinite de Itaú reciben junto con ésta la tarjeta Priority Pass. La misma permite ser parte del programa independiente de acceso a salas VIP de aeropuertos más amplio del mundo.',
        'La tarjeta Priority Pass te brinda 7 accesos gratis al año (calendario). A partir del octavo acceso, se cargará a la tarjeta de crédito del titular cada acceso adicional a USD 27. ',
        'Para ver la lista de Salas Vip adheridas y bases y condiciones hacé <a href="https://www.prioritypass.com/en/airport-lounges">click aquí</a>.',
      ],
    },
    {
      title: 'Servicio de asistencia médica en Viaje: Cobertura brindada por Universal Assistance',
      icon: 'lock',
      content: [
        '<strong>Área de Cobertura:</strong> Todo el mundo (excepto la República Oriental del Uruguay).',
        '<strong>Beneficiarios:</strong> Tarjeta habientes, cónyuges e hijos dependientes menores de 21 años.',
        '<strong>Prestaciones:</strong> Asistencia Médica, Odontológica, Jurídica y Localización de Equipaje.',
        'Los beneficiarios cuentan con el Servicio de Asistencia en Viajes que brinda Universal Assistance de hasta USD 15.000 por persona.',
        'Para solicitar la asistencia a través de Universal Assistance siempre deberás comunicarse con la central operativa correspondiente al lugar donde te encuentres, mediante cobro revertido.',
        '<a href="https://www.itau.com.uy/inst/aci/docs/condiciones_generales.pdf">Ver condiciones</a>',
      ],
    },
    {
      title: 'Cobertura brindada por AXA USA',
      // icon: '',
      content: [
        'Además, si se abona el pasaje de avión con Itaú Visa Platinum, cuentan con la siguiente cobertura a través de AXA USA (*).',
        'Asistencia en Viajes de hasta un máximo de USD 50.000 en todo el mundo.',
        '<strong>Beneficiarios:</strong> titular, cónyuge e hijos menores de 23 años.',
        '<strong>(*)</strong> Los seguros de Asistencia en Viajes no son acumulables.',
        '<strong>(**)</strong> Países firmantes del tratado Schengen.',
        'Para solicitar la asistencia a través de AXA siempre deberás comunicarse con la central operativa correspondiente al lugar donde te encuentres, mediante cobro revertido. Hacé <a href="https://www.itau.com.uy/inst/aci/docs/Seguros%20AXA.pdf">click aquí</a> para ver los números de teléfono.',
        '<a href="https://www.itau.com.uy/inst/aci/docs/servicios_de_emergencia_medica_internacional_AXA_platinum.pdf">Ver condiciones</a>',
        'Si querés solicitar el certificado Schengen para viajes a Europa, regístrate en el portal de Visa haciendo <a href="https://visabenefitslac.axa-assistance.us/">click aquí</a>.',
      ],
    },
    {
      title: 'Seguros',
      // icon: 'more',
      content: [
        'Por más información sobre seguros <a href="https://www.visa.com.uy/pague-con-visa/tarjetas/credito/visa-infinite.html">clic aquí</a>.',
      ],
    },
    {
      title: 'Adicionales sin cargo',
      icon: 'plusone',
      content: [
        'La primera adicional es sin cargo. Además las tarjetas adicionales también acumulan Dots en la cuenta titular. La tarjeta Visa On Infinite del titular y sus adicionales no tienen costo de emisión por un año.',
      ],
    },
    {
      title: 'Tipo de emisión',
      icon: 'document',
      content: [
        'La tarjeta Visa On Infinite tiene un tipo de emisión automática. Esto significa que simplemente completando el formulario de solicitud, <strong>nuestro sistema validará automáticamente tu tarjeta sin que tengas que presentar documentación ni recibos de sueldo</strong>. Si tus datos validan con nuestro sistema, tu tarjeta queda aprobada y te la enviamos en 48 horas sin moverte de tu casa ',
      ],
    },
    {
      title: 'Bono de 50 Dots',
      icon: 'star',
      content: ['Bono bienvenida de 50 Dots.'],
    },
    {
      title: 'Dots por consumo',
      icon: 'cart',
      content: [
        'Todos los consumos que realizás con esta tarjeta generarán Dots, a excepción de los retiros de dinero en efectivo y los cargos por intereses o cargos bancarios (comisiones).',
        'El consumo de combustible y los débitos automáticos también generan Dots.',
      ],
    },
  ],
};

export default on;
